module.exports = __webpack_public_path__ + "static/images/styles/images/cancel.9e7d70d3.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/cancel.png
// module id = 3610
// module chunks = 11